import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/lockicon.svg'
import _imports_1 from '../../../assets/icons/user.svg'
import _imports_2 from '../../../assets/images/logo/iknowa-logo-v4.svg'
import _imports_3 from '../../../assets/icons/connections.svg'
import _imports_4 from '../../../assets/icons/building-filled-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5335203c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-w-full tw-flex tw-gap-3 tw-rounded-[10px] tw-p-3 tw-box-border tw-bg-[rgba(255,165,0,0.2)] tw-border-solid tw-border tw-border-[rgba(255,165,0,1)]"
}
const _hoisted_2 = {
  key: 1,
  class: "tw-w-full tw-flex tw-gap-3 tw-rounded-[10px] tw-p-3 tw-box-border tw-bg-[rgba(255,165,0,0.2)] tw-border-solid tw-border tw-border-[rgba(255,165,0,1)]"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  class: "unlock_platform"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Unlock all areas of iknowa platform for free* until 1st April 2025. ", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 4,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full tw-mt-[600px] md:!tw-mt-[301px]"
}
const _hoisted_9 = { class: "profile__header" }
const _hoisted_10 = { class: "tw-w-full" }
const _hoisted_11 = {
  key: 1,
  class: "tw-w-full tw-flex tw-flex-col tw-items-center tw-gap-4 tw-justify-start md:!tw-items-start rmd:tw-flex-row rmd:tw-justify-between"
}
const _hoisted_12 = { class: "tw-flex tw-flex-col tw-gap-5 tw-items-start md:!tw-w-full" }
const _hoisted_13 = { class: "tw-w-full tw-flex tw-items-center tw-gap-3 rmd:tw-gap-2" }
const _hoisted_14 = {
  key: 1,
  class: "tw-rounded-full tw-max-h-[104px] tw-max-w-[104px] tw-min-h-[104px] tw-min-w-[104px] tw-h-[104px] tw-relative"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "tw-flex tw-flex-col tw-items-start" }
const _hoisted_17 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_18 = {
  key: 0,
  class: "tw-flex tw-items-start tw-gap-0 rmd:tw-gap-1"
}
const _hoisted_19 = { class: "view-rating-box md:!tw-gap-[4px] !tw-justify-between md:!tw-max-w-[unset] md:!tw-w-full md:!tw-p-[.5rem]" }
const _hoisted_20 = { class: "tw-flex tw-items-center tw-gap-[8px] md:!tw-gap-[4px]" }
const _hoisted_21 = { class: "md:!tw-text-[12px]" }
const _hoisted_22 = { class: "tw-flex tw-flex-col tw-w-full tw-items-center tw-justify-between tw-relative rsm:tw-items-end rsm:tw-w-[auto] md:tw-hidden tw-min-h-[130px] tw-gap-8" }
const _hoisted_23 = { class: "custom__chip" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_25 = {
  key: 5,
  class: "tw-flex tw-flex-col tw-gap-6 rlg:!tw-gap-8 tw-max-w-[1332px] rlg:tw-mt-4"
}
const _hoisted_26 = { class: "tw-w-full tw-flex tw-flex-col tw-justify-between tw-h-full" }
const _hoisted_27 = {
  key: 0,
  class: "tw-w-full tw-flex tw-items-center tw-justify-between tw-pb-4 tw-box-border"
}
const _hoisted_28 = { class: "tw-flex tw-items-center tw-gap-4 md:!tw-flex-col md:!tw-items-start md:!tw-gap-[.5rem] md:!tw-w-full" }
const _hoisted_29 = {
  key: 1,
  class: "tw-w-full tw-flex tw-flex-col tw-gap-8 tw-pt-5 tw-box-border tw-overflow-auto no-scrollbar"
}
const _hoisted_30 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-4 tw-border-b tw-border-0 tw-border-dashed tw-border-[#C5D2F2] tw-pb-5"
}
const _hoisted_31 = { class: "md:tw-border-0 md:tw-pb-3 md:tw-border-b md:tw-border-dashed md:tw-border-[#8687A5] tw-w-full" }
const _hoisted_32 = { class: "chip-state tw-w-fit tw-px-[.5rem] tw-py-[.2rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_33 = { class: "tw-w-full tw-flex tw-items-center md:tw-items-start tw-gap-2 rmd:!tw-items-start tw-mt-3" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "tw-w-full tw-flex md:tw-flex-col md:tw-items-start tw-justify-between tw-items-center tw-gap-2 tw-flex-wrap" }
const _hoisted_36 = { class: "tw-flex tw-flex-col tw-item-start" }
const _hoisted_37 = { class: "tw-flex tw-items-center tw-gap-2 md:tw-flex-col-reverse md:tw-items-start" }
const _hoisted_38 = { class: "tw-flex tw-gap-2 tw-items-center" }
const _hoisted_39 = { class: "chip-state tw-px-[.5rem] tw-py-[.2rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_40 = {
  key: 0,
  class: "tag-wrapper !tw-flex tw-items-center tw-justify-start tw-gap-[.5rem] md:!tw-flex-wrap tw-mt-2"
}
const _hoisted_41 = { class: "tw-px-[.5rem] tw-py-[.2rem] tw-box-border tw-text-[14px] tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#0c0f4a1a] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_42 = { class: "tw-flex tw-items-start tw-flex-col" }
const _hoisted_43 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-2" }
const _hoisted_44 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2 tw-flex-wrap"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-[3px]" }, "Reject", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-[3px]" }, "Accept", -1))
const _hoisted_47 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_48 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_49 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-3 tw-justify-between" }
const _hoisted_50 = { class: "tw-flex tw-items-center tw-w-full tw-justify-between md:tw-border-0 md:tw-pb-3 md:tw-border-b md:tw-border-dashed md:tw-border-[#8687A5] s430:tw-gap-2" }
const _hoisted_51 = { class: "chip-state tw-px-[.5rem] tw-py-[.2rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_52 = { class: "tw-items-center tw-gap-2 tw-flex-wrap tw-relative md:tw-flex tw-hidden" }
const _hoisted_53 = {
  key: 0,
  class: "notification__count tw-absolute tw-top-0 tw-left-7 tw-w-[18px] tw-h-[18px] tw-bg-[#FFA500] tw-rounded-full tw-text-center tw-flex tw-items-center tw-justify-center"
}
const _hoisted_54 = { class: "tw-w-full tw-flex tw-items-center md:tw-items-start tw-gap-2 rmd:!tw-items-start tw-mt-3" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-2 tw-flex-wrap tw-w-[calc(100%_-_64px)] md:!tw-flex-col md:!tw-items-start" }
const _hoisted_57 = { class: "tw-flex tw-flex-col tw-item-start tw-gap-[2px]" }
const _hoisted_58 = { class: "tw-flex tw-items-center tw-gap-2 md:tw-flex-col-reverse md:tw-items-start" }
const _hoisted_59 = {
  key: 0,
  class: "chip-state tw-px-[.5rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize !tw-py-0"
}
const _hoisted_60 = {
  key: 1,
  class: "chip-state tw-px-[.5rem] tw-text-[14px] tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F98228]/[0.26] tw-text-[#0C0F4A] tw-font-medium tw-capitalize !tw-py-0"
}
const _hoisted_61 = {
  key: 0,
  class: "tag-wrapper !tw-flex tw-items-center tw-justify-start tw-gap-[.5rem] md:!tw-flex-wrap tw-mt-2"
}
const _hoisted_62 = { class: "tw-px-[.5rem] tw-py-[.2rem] tw-box-border tw-text-[14px] tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#0c0f4a1a] tw-text-[#0C0F4A] tw-font-medium tw-capitalize" }
const _hoisted_63 = { class: "tw-h-full tw-flex tw-items-start tw-flex-col tw-justify-between tw-gap-[3px]" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center" }, null, -1))
const _hoisted_65 = { class: "tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-relative md:tw-hidden" }
const _hoisted_66 = {
  key: 0,
  class: "notification__count tw-absolute tw-top-0 tw-left-7 tw-w-[18px] tw-h-[18px] tw-bg-[#FFA500] tw-rounded-full tw-text-center tw-flex tw-items-center tw-justify-center"
}
const _hoisted_67 = { class: "tw-hidden md:tw-block md:tw-mt-3 md:tw-ml-auto" }
const _hoisted_68 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-pt-5 tw-border-t-solid-custom s540:!tw-flex-col s540:!tw-items-start" }
const _hoisted_69 = {
  key: 0,
  class: "tw-flex tw-items-center"
}
const _hoisted_70 = {
  key: 2,
  class: "tw-w-full tw-flex tw-items-center tw-gap-6 lg:!tw-flex-col"
}
const _hoisted_71 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-6 lg:!tw-w-full" }
const _hoisted_72 = { class: "tw-flex tw-items-center tw-gap-6 lg:!tw-flex-col lg:!tw-w-full lg:!tw-items-start" }
const _hoisted_73 = { class: "tw-min-w-[292px] tw-w-full sign-up-empty-state-banner tw-px-6 tw-py-4 tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-2 tw-bg-[rgba(197,210,242,0.24)] tw-rounded-lg" }
const _hoisted_74 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = ["src"]
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "tw-w-full tw-flex-col tw-bg-white tw-border-solid-default tw-px-8 tw-box-border tw-py-6 tw-flex tw-items-start tw-gap-6 tw-rounded-[16px] rxl:!tw-flex-row" }
const _hoisted_79 = ["src"]
const _hoisted_80 = { class: "tw-flex tw-flex-col tw-gap-4 tw-items-start" }
const _hoisted_81 = { class: "tw-w-full tw-flex tw-gap-8 md:!tw-gap-6 lg:!tw-flex-col" }
const _hoisted_82 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-8 md:!tw-gap-6" }
const _hoisted_83 = { class: "tw-flex tw-flex-col tw-items-start tw-justify-between" }
const _hoisted_84 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-6" }
const _hoisted_85 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_86 = ["src"]
const _hoisted_87 = { class: "tw-w-full tw-flex tw-flex-col-reverse tw-justify-end tw-items-center tw-gap-4 tw-box-border tw-pb-4 rmd:!tw-flex-row-reverse" }
const _hoisted_88 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3 tw-justify-between" }
const _hoisted_89 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_90 = { class: "tw-w-full tw-h-full tw-max-h-[100px] tw-h-[100px] tw-min-h-[100px] tw-rounded-[6px] tw-overflow-hidden" }
const _hoisted_91 = ["src"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "md:!tw-hidden" }, null, -1))
const _hoisted_93 = { class: "tw-flex tw-items-center tw-gap-2 tw-justify-start" }
const _hoisted_94 = { class: "tw-flex tw-flex-col tw-items-start tw-justify-between" }
const _hoisted_95 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-6 tw-pb-4" }
const _hoisted_96 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_97 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_98 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-border-0 tw-pb-2" }
const _hoisted_99 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_100 = { class: "tw-w-auto tw-px-2 tw-box-border tw-rounded-[4px] tw-bg-[rgba(79,85,240,0.1)] tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-[#4F55F0]" }
const _hoisted_101 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_102 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_103 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-pt-5 tw-border-t-solid-custom" }
const _hoisted_104 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-8 md:!tw-gap-6" }
const _hoisted_105 = { class: "tw-flex tw-items-start tw-gap-8 md:!tw-gap-6 md:!tw-flex-col" }
const _hoisted_106 = ["src"]
const _hoisted_107 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between" }
const _hoisted_108 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-6" }
const _hoisted_109 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_110 = { class: "tw-flex tw-w-full tw-items-start tw-gap-4 !tw-hidden" }
const _hoisted_111 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3 tw-justify-between" }
const _hoisted_112 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3" }
const _hoisted_113 = { class: "tw-w-full tw-h-full tw-max-h-[80px] tw-h-[80px] tw-min-h-[80px] tw-rounded-[6px] tw-overflow-hidden tw-flex tw-items-center" }
const _hoisted_114 = ["src"]
const _hoisted_115 = { class: "tw-flex tw-flex-col tw-gap-0 tw-items-start" }
const _hoisted_116 = { class: "tw-flex tw-items-center tw-gap-2 tw-justify-start" }
const _hoisted_117 = { class: "tw-flex tw-items-center tw-gap-2 tw-justify-start" }
const _hoisted_118 = { class: "tw-flex tw-items-center tw-gap-2 tw-justify-start" }
const _hoisted_119 = { class: "tw-flex tw-items-center tw-gap-8 md:!tw-gap-6 md:!tw-flex-col md:tw-items-start" }
const _hoisted_120 = ["src"]
const _hoisted_121 = { class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-justify-between" }
const _hoisted_122 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-6 tw-pb-2" }
const _hoisted_123 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-col tw-items-start tw-gap-4" }, null, -1))
const _hoisted_125 = { class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-pt-5 tw-border-t-solid-custom" }
const _hoisted_126 = {
  key: 6,
  class: "workstation-dashboard tw-flex tw-flex-col tw-gap-6 tw-w-full tw-h-full"
}
const _hoisted_127 = { class: "tw-w-full tw-h-full tw-grid tw-grid-cols-1 tw-gap-6 tw-box-border rlg:tw-grid-cols-2" }
const _hoisted_128 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6" }
const _hoisted_129 = { class: "icon-title !tw-flex !tw-flex-col !tw-items-start tw-gap-2" }
const _hoisted_130 = { class: "icon-title__inner" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, " Setting Up Your iknowa Workstation ", -1))
const _hoisted_132 = { class: "progress-wrap" }
const _hoisted_133 = { class: "progress-wrap-title" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, "Your iknowa account setup", -1))
const _hoisted_135 = { class: "progress-list" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress-list__counter" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress-list__text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, "Create a Trade Workstation"),
  /*#__PURE__*/_createElementVNode("span", null, "Access document storage, create calendar events & invite others.")
], -1))
const _hoisted_138 = [
  _hoisted_136,
  _hoisted_137
]
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2", -1))
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = { class: "progress-list__text" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Build trust and legitimacy for your business.", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3", -1))
const _hoisted_144 = [
  _hoisted_143
]
const _hoisted_145 = { class: "progress-list__text" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Increase clients trust & win more Jobs", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3", -1))
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = { class: "progress-list__text" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Increase clients trust & win more Jobs", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "4 ", -1))
const _hoisted_152 = [
  _hoisted_151
]
const _hoisted_153 = { class: "progress-list__text" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Specialisms, Certificates, Insurances and other details.", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "5", -1))
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = { class: "progress-list__text" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Access courses, jobs & trade network.", -1))
const _hoisted_159 = { class: "tw-w-full tw-mt-4 tw-flex tw-flex-col tw-gap-2 tw-justify-center tw-items-center rmd:tw-flex-row rmd:tw-justify-between" }
const _hoisted_160 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6 no-scroll tw-max-h-[1100px]" }
const _hoisted_161 = { class: "modal_wrapper" }
const _hoisted_162 = { class: "main" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-dots" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-blue" }),
  /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" })
], -1))
const _hoisted_164 = { class: "switching-text" }
const _hoisted_165 = { class: "previous_btn" }
const _hoisted_166 = { class: "main" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "custom__modal__header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_2
  }),
  /*#__PURE__*/_createElementVNode("h4", null, "Business Setup")
], -1))
const _hoisted_168 = { class: "custom__modal__content" }
const _hoisted_169 = { class: "custom__modal__heading tw-flex tw-flex-col tw-gap-3 rmd:tw-gap-4" }
const _hoisted_170 = { class: "custom__modal__head" }
const _hoisted_171 = { class: "!tw-capitalize" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_173 = { class: "custom__modal__card" }
const _hoisted_174 = { class: "icon_btn" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Sole Trader"),
  /*#__PURE__*/_createElementVNode("p", null, "Trading as Individual")
], -1))
const _hoisted_177 = { class: "icon_btn" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Limited Company"),
  /*#__PURE__*/_createElementVNode("p", null, "Registered on Companies House")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoticeIcon = _resolveComponent("NoticeIcon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_WorkStationVerificationLock = _resolveComponent("WorkStationVerificationLock")!
  const _component_ProfileThumbnail = _resolveComponent("ProfileThumbnail")!
  const _component_CheckGreenShield = _resolveComponent("CheckGreenShield")!
  const _component_InfoIconRed = _resolveComponent("InfoIconRed")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_ChipState = _resolveComponent("ChipState")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_Postcode = _resolveComponent("Postcode")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_SiltRequiredChip = _resolveComponent("SiltRequiredChip")!
  const _component_ProfileVerificationStatusChip = _resolveComponent("ProfileVerificationStatusChip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_WorkStationProfileLogo = _resolveComponent("WorkStationProfileLogo")!
  const _component_InfoIconWhite = _resolveComponent("InfoIconWhite")!
  const _component_CheckIconWhite = _resolveComponent("CheckIconWhite")!
  const _component_NotificationIcon = _resolveComponent("NotificationIcon")!
  const _component_LunchIcon = _resolveComponent("LunchIcon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_DeleteActionChip = _resolveComponent("DeleteActionChip")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_MapMarkerBlueIcon = _resolveComponent("MapMarkerBlueIcon")!
  const _component_ApproveChip = _resolveComponent("ApproveChip")!
  const _component_PendingChip = _resolveComponent("PendingChip")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_MapMarkerYellowIcon = _resolveComponent("MapMarkerYellowIcon")!
  const _component_WorkStationVerificationProgress = _resolveComponent("WorkStationVerificationProgress")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_JobsOverviewWidget = _resolveComponent("JobsOverviewWidget")!
  const _component_TeamWidget = _resolveComponent("TeamWidget")!
  const _component_TradeNetworkWidget = _resolveComponent("TradeNetworkWidget")!
  const _component_CalendarEventWidget = _resolveComponent("CalendarEventWidget")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AddEmailModal = _resolveComponent("AddEmailModal")!
  const _component_EmailConformModal = _resolveComponent("EmailConformModal")!
  const _component_SoleTraderWorkStationComponent = _resolveComponent("SoleTraderWorkStationComponent")!
  const _component_LimitedCompanyWorkStationComponent = _resolveComponent("LimitedCompanyWorkStationComponent")!
  const _component_InsuranceModel = _resolveComponent("InsuranceModel")!
  const _component_CertificationModal = _resolveComponent("CertificationModal")!
  const _component_TaxAndVatModel = _resolveComponent("TaxAndVatModel")!
  const _component_InviteMemberForm = _resolveComponent("InviteMemberForm")!
  const _component_WorkstationVerificationModal = _resolveComponent("WorkstationVerificationModal")!
  const _component_NewWorkstationSubscriptionModal = _resolveComponent("NewWorkstationSubscriptionModal")!
  const _component_UnlockFreeAccessModal = _resolveComponent("UnlockFreeAccessModal")!
  const _component_StartIDVerificationModal = _resolveComponent("StartIDVerificationModal")!
  const _component_AddAddressModal = _resolveComponent("AddAddressModal")!
  const _component_AddUserRatesModal = _resolveComponent("AddUserRatesModal")!
  const _component_SpecialismMultiSelectModel = _resolveComponent("SpecialismMultiSelectModel")!
  const _component_CreateTradeWSModal = _resolveComponent("CreateTradeWSModal")!
  const _component_WelcomeTradePersonPopup = _resolveComponent("WelcomeTradePersonPopup")!
  const _component_TradePersonBenefitsModal = _resolveComponent("TradePersonBenefitsModal")!
  const _component_AddBusinessAddressPreviewModal = _resolveComponent("AddBusinessAddressPreviewModal")!
  const _component_CompleteIDVerificationPreviewModal = _resolveComponent("CompleteIDVerificationPreviewModal")!
  const _component_TradePassportPreviewModal = _resolveComponent("TradePassportPreviewModal")!
  const _component_WorkstationForVerificationPreviewModal = _resolveComponent("WorkstationForVerificationPreviewModal")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!
  const _component_BuySpotConfirmation = _resolveComponent("BuySpotConfirmation")!
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")!
  const _component_PaymentStatusModal = _resolveComponent("PaymentStatusModal")!
  const _component_HasSpotNotice = _resolveComponent("HasSpotNotice")!
  const _component_HasReservedSpotNotice = _resolveComponent("HasReservedSpotNotice")!
  const _component_AssignCourseSlotToMemberModal = _resolveComponent("AssignCourseSlotToMemberModal")!
  const _component_TpSubscriptionModal = _resolveComponent("TpSubscriptionModal")!
  const _component_SuccessWorkstationCreationModal = _resolveComponent("SuccessWorkstationCreationModal")!
  const _component_RejectConfirmationModal = _resolveComponent("RejectConfirmationModal")!
  const _component_PropertyOwnerTermsConditionModal = _resolveComponent("PropertyOwnerTermsConditionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", {
      class: _normalizeClass(["dashboard-sec !tw-flex !tw-flex-col tw-gap-6 tw-pb-8 tw-box-border rmd:tw-gap-6 tw-relative md:!tw-pb-16", {
      '!tw-items-center !tw-justify-center md:!tw-gap-0':
        $setup.isUserWorkstationIsDefault,
    }])
    }, [
      ($setup.getSoloTraderAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_NoticeIcon),
            (
          !$setup.activeUserWorkstation?.user?.userBusinessDetails
            ?.residencyPostcode &&
          $setup.userBusinessType === $setup.BusinessDetailTypeEnum.SOLETRADER
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 0,
                  variant: "span",
                  textColor: "#0C0F4A"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Add Business Address. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickAddBusinessAddressModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Manage Address")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          $setup.activeUserWorkstation?.user?.userKYCVerificationStatus ===
            $setup.UserVerificationStatusEnum.NOT_ADDED &&
          $setup.activeUserWorkstation?.user?.userBusinessDetails?.residencyPostcode &&
          $setup.userBusinessType === $setup.BusinessDetailTypeEnum.SOLETRADER &&
          $setup.activeUserWorkstation?.verificationStatus !==
            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 1,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Complete ID Verification. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickIDVerificationModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Get Verified")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          ($setup.userBusinessType === $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
            ? $setup.activeUserWorkstation?.user?.userBusinessDetails?.businessPostcode
            : $setup.activeUserWorkstation?.user?.userBusinessDetails
                ?.residencyPostcode) &&
          ($setup.activeUserWorkstation?.user?.userKYCVerificationStatus ===
            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION ||
            $setup.activeUserWorkstation?.user?.userKYCVerificationStatus ===
              $setup.UserVerificationStatusEnum.VERIFIED) &&
          !$setup.isUserProfileVerified
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 2,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Complete Your Trade Passport. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickManageTradePassportPreviewModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Manage Trade Passport")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          $setup.activeUserWorkstation?.verificationStatus ==
            $setup.UserVerificationStatusEnum.NOT_ADDED &&
          $setup.isUserProfileVerified &&
          $setup.activeUserWorkstation?.user?.userBusinessDetails?.residencyPostcode &&
          $setup.activeUserWorkstation?.user?.userKYCVerificationStatus !==
            $setup.UserVerificationStatusEnum.NOT_ADDED
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 3,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Complete Workstation Verification. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickSubmitVerificationPreviewModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Get Verified")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          $setup.activeUserWorkstation?.verificationStatus ==
            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION &&
          $setup.isUserProfileVerified &&
          $setup.activeUserWorkstation?.user?.userBusinessDetails?.residencyPostcode
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 4,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Verification Pending. ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ($setup.getLimitedCompanyAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_NoticeIcon),
            (
          !$setup.activeUserWorkstation?.user?.userBusinessDetails?.businessPostcode &&
          $setup.userBusinessType === $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 0,
                  variant: "span",
                  textColor: "#0C0F4A"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Add Business Address. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickAddBusinessAddressModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Manage Address")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          !$setup.WorkStationSiltVerificationStatus &&
          $setup.activeUserWorkstation?.user?.userBusinessDetails?.businessPostcode &&
          $setup.userBusinessType === $setup.BusinessDetailTypeEnum.LIMITED_COMPANY &&
          $setup.userWorkStationStatus !==
            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 1,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Complete ID & Business Verification. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickIDVerificationModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Get Verified")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString($setup.WorkStationSiltVerificationStatus) + " ", 1),
            (
          ($setup.WorkStationSiltVerificationStatus &&
          $setup.userBusinessType === $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
            ? $setup.activeUserWorkstation?.user?.userBusinessDetails?.businessPostcode
            : $setup.activeUserWorkstation?.user?.userBusinessDetails
                ?.residencyPostcode) &&
          ($setup.activeUserWorkstation?.user?.userKYCVerificationStatus ===
            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION ||
            $setup.activeUserWorkstation?.user?.userKYCVerificationStatus ===
              $setup.UserVerificationStatusEnum.VERIFIED) &&
          !$setup.isUserProfileVerified
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 2,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Complete Your Trade Passport. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickManageTradePassportPreviewModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Manage Trade Passport")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          !$setup.isUserWorkstationIsDefault &&
          $setup.isUserVerifiedKYCAndKYB &&
          $setup.isUserProfileVerified &&
          ($setup.userBusinessType === $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
            ? $setup.activeUserWorkstation?.user?.userBusinessDetails?.businessPostcode
            : $setup.activeUserWorkstation?.user?.userBusinessDetails
                ?.residencyPostcode) &&
          $setup.userWorkStationStatus === $setup.UserVerificationStatusEnum.NOT_ADDED
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 3,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Complete Workstation Verification. "),
                    _createVNode(_component_Text, {
                      class: "tw-cursor-pointer tw-underline",
                      variant: "span",
                      textColor: "#4B4BFF",
                      onClick: $setup.onClickSubmitVerificationPreviewModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Get Verified")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
          !$setup.isUserWorkstationIsDefault &&
          $setup.activeUserWorkstation?.verificationStatus ===
            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION &&
          $setup.isUserProfileVerified &&
          ($setup.userBusinessType === $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
            ? $setup.activeUserWorkstation?.user?.userBusinessDetails?.businessPostcode
            : $setup.activeUserWorkstation?.user?.userBusinessDetails
                ?.residencyPostcode)
        )
              ? (_openBlock(), _createBlock(_component_Text, {
                  key: 4,
                  variant: "span",
                  textColor: "#FA4B00"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Action Required: Verification Pending. ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!$setup.isUserWorkstationIsDefault)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (
          !$setup.activeUserWorkstation?.subscription ||
          ($setup.activeUserWorkstation?.subStatus !==
            $setup.UserWorkstationSubStatusEnum.SUCCEEDED &&
            $setup.activeUserWorkstation?.user?.userKYCVerificationStatus ===
              $setup.UserVerificationStatusEnum.NOT_ADDED &&
            $setup.activeUserWorkstation?.user?.userBusinessDetails
              ?.residencyPostcode &&
            $setup.activeUserWorkstation?.verificationStatus !==
              $setup.UserVerificationStatusEnum.PENDING_VERIFICATION &&
            $setup.showBanner)
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _hoisted_6,
                  _createVNode(_component_v_btn, {
                    class: "unlock_button",
                    variant: "outlined",
                    onClick: $setup.toggleUnlockFreeAccessModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Unlock for free now ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (
        !$setup.isUserWorkstationIsDefault &&
        $setup.coursesWithRemainingSlots?.length &&
        $setup.activeUserWorkstation?.verificationStatus ===
          $setup.UserVerificationStatusEnum.VERIFIED &&
        !$setup.userInsurenceExperiedStatus &&
        !$setup.isWorkstationLoading
      )
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList($setup.coursesWithRemainingSlots.slice(0, 1), (courses) => {
            return (_openBlock(), _createElementBlock("div", {
              key: courses?.id,
              class: "note__wrapper"
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-information" }),
              _createElementVNode("p", null, [
                _createTextVNode(" assign members to the available spots for the " + _toDisplayString(courses?.course?.name) + ". ", 1),
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => ($setup.toggleAssignCourseSlotToMemberModal(courses?.id)), ["prevent"])
                }, "Assign members", 8, _hoisted_7)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      ($setup.isWorkstationLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Loader, { show: $setup.isWorkstationLoading }, null, 8, ["show"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (!$setup.isUserWorkstationIsDefault && !$setup.isWorkstationLoading)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              withBorder: true,
              isRoundedxl: true,
              class: "!tw-max-h-[unset] tw-w-full !tw-py-6 !tw-px-4 rmd:!tw-py-8 rmd:!tw-px-6 tw-box-border tw-relative"
            }, {
              content: _withCtx(() => [
                _createElementVNode("main", _hoisted_10, [
                  (
                $setup.userWorkStationStatus ===
                  $setup.UserVerificationStatusEnum.PENDING_VERIFICATION &&
                !$setup.isWorkstationLoading
              )
                    ? (_openBlock(), _createBlock(_component_WorkStationVerificationLock, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!$setup.isUserWorkstationIsDefault)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            ($setup.userWorkStationImage)
                              ? (_openBlock(), _createBlock(_component_ProfileThumbnail, {
                                  key: 0,
                                  isRounded: false,
                                  desktopFontSizeBig: true,
                                  class: "ws-profile-logo",
                                  size: "xllg",
                                  src: $setup.userWorkStationImage,
                                  isVerified: 
                      $setup.activeUserWorkstation?.verificationStatus ===
                      $setup.UserVerificationStatusEnum.VERIFIED
                    ,
                                  showVerificationIcon: true,
                                  userKycStatus: $setup.userVerifyStatus
                                }, null, 8, ["src", "isVerified", "userKycStatus"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  ($setup.userVerifyStatus != 0)
                                    ? (_openBlock(), _createBlock(_component_ChipState, {
                                        key: 0,
                                        bgColor: "#FFF",
                                        hasShadow: true,
                                        class: "tw-absolute tw-top-[-.3rem] tw-right-[-.4rem] tw-z-10 !tw-w-6 !tw-h-6 !tw-px-0 !tw-py-0 !tw-gap-0"
                                      }, {
                                        prefix: _withCtx(() => [
                                          _createVNode(_component_el_tooltip, {
                                            effect: "light",
                                            placement: "bottom-start"
                                          }, {
                                            content: _withCtx(() => [
                                              _createElementVNode("div", {
                                                class: "tw-max-w-[200px]",
                                                innerHTML: $setup.toolTipProfile
                                              }, null, 8, _hoisted_15)
                                            ]),
                                            default: _withCtx(() => [
                                              ($setup.userVerifyStatus == 2)
                                                ? (_openBlock(), _createBlock(_component_CheckGreenShield, { key: 0 }))
                                                : (_openBlock(), _createBlock(_component_InfoIconRed, {
                                                    key: 1,
                                                    color: `#faa500`
                                                  }))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_UserProfileLogo, {
                                    class: "ws-profile-logo !tw-w-full !tw-h-full",
                                    desktopFontSizeBig: true,
                                    isRounded: false,
                                    mobileFontSizeBig: true
                                  })
                                ])),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_Text, {
                                  class: "rmd:!tw-text-2xl",
                                  variant: "h6",
                                  isCapitalize: true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.activeUserWorkstation?.name), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              (
                        $setup.workstationAddress(
                          $setup.activeUserWorkstation?.user?.userBusinessDetails?.type
                        ) &&
                        $setup.workstationAddress(
                          $setup.activeUserWorkstation?.user?.userBusinessDetails?.type
                        ) !== 'null null'
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_Text, {
                                      class: "!tw-text-[10px] md:!tw-text-[11px] !tw-leading-4 !tw-mt-1.5",
                                      textWeight: "400",
                                      textColor: "#0C0F4A",
                                      whiteSpace: "pre-wrap"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.workstationAddress(
                            $setup.activeUserWorkstation?.user?.userBusinessDetails
                              ?.type
                          )), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Postcode, {
                                      value: 
                          $setup.workstationPostcode(
                            $setup.activeUserWorkstation?.user?.userBusinessDetails
                              ?.type
                          )
                        
                                    }, null, 8, ["value"])
                                  ]))
                                : ($setup.getUserWorkStationFieldAccess)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onClickAddress && $setup.onClickAddress(...args))),
                                      class: "tw-flex tw-gap-1 tw-items-center tw-cursor-pointer"
                                    }, [
                                      _createVNode(_component_Text, {
                                        textColor: "#FFA500",
                                        variant: "p"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("+")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_Text, {
                                        textColor: "#FFA500",
                                        variant: "span"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Add Address")
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_v_rating, {
                                "active-color": "orange",
                                modelValue: $setup.getAverageOfAllProjectReview,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.getAverageOfAllProjectReview) = $event)),
                                color: "rgba(12, 15, 74, 0.26)",
                                "empty-icon": "mdi-star",
                                readonly: ""
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("p", _hoisted_21, _toDisplayString($setup.getAverageOfAllProjectReview) + " out of 5 ", 1)
                            ]),
                            _createVNode(_component_v_btn, {
                              class: "button button-orange",
                              "append-icon": "mdi-chevron-right",
                              onClick: $setup.onClickViewRatings
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("view Ratings ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_ChipState, {
                            class: "tw-border-solid tw-border-[1px] tw-border-[#0C0F4A] tw-cursor-pointer tw-h-[25px] tw-hidden md:tw-block md:tw-ml-auto",
                            label: "VIEW TRADE PASSPORT",
                            textColor: "#0C0F4A",
                            isDense: true,
                            onClick: $setup.onClickManageTradePassport
                          }, null, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("span", null, _toDisplayString($setup.activeWorkStationType($setup.user?.userBusinessDetails?.type)), 1)
                          ]),
                          (
                    !$setup.WorkStationSiltVerificationStatus &&
                    $setup.userBusinessType === $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
                  )
                            ? (_openBlock(), _createBlock(_component_SiltRequiredChip, { key: 0 }))
                            : _createCommentVNode("", true),
                          (
                    $setup.userBusinessType === $setup.BusinessDetailTypeEnum.SOLETRADER &&
                    $setup.userVerifyStatus === $setup.UserVerificationStatusEnum.NOT_ADDED
                  )
                            ? (_openBlock(), _createBlock(_component_ProfileVerificationStatusChip, {
                                key: 1,
                                class: "tw-hidden rmd:tw-flex",
                                variant: $setup.userWorkstationStatusByWord
                              }, null, 8, ["variant"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Button, {
                            class: "!tw-w-auto !tw-py-0 tw-box-border !tw-text-[#FFA500]",
                            variant: "custom",
                            onClick: $setup.onClickManageTradePassport,
                            label: "Manage Trade Passport",
                            activeBgColor: "transparent",
                            width: "auto",
                            isCapitalize: true,
                            fontWeight: 700
                          }, {
                            postfix: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-chevron-right",
                                color: "#FFA500"
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (
        $setup.isUserWorkstationIsDefault &&
        $setup.activeUserWorkstation &&
        !$setup.isWorkstationLoading
      )
        ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
            _createVNode(_component_Text, {
              variant: "h4",
              class: "tw-mb-4 tw-capitalize rmd:!tw-text-[32px] md:!tw-mb-0",
              isCapitalize: true
            }, {
              default: _withCtx(() => [
                _createTextVNode("Hello, " + _toDisplayString($setup.user?.firstName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Card, {
              class: _normalizeClass(["manage-ws-card !tw-max-h-[unset] tw-w-full tw-box-border md:tw-p-6 tw-p-4", {
          '!tw-px-8 !tw-py-6 md:!tw-px-4':
            !$setup.filteredUserAllWorkStation.length && !$setup.WorkStationInvitation.length,
        }]),
              withBorder: true,
              bgColor: "rgba(241, 246, 251, 0.50)",
              isRoundedxl: 
          !$setup.filteredUserAllWorkStation.length && !$setup.WorkStationInvitation.length
        
            }, {
              content: _withCtx(() => [
                _createElementVNode("main", _hoisted_26, [
                  (
                $setup.filteredUserAllWorkStation.length ||
                $setup.WorkStationInvitation.length
              )
                    ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_Text, { class: "!tw-text-[20px] rlg:!tw-text-[28px]" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Launch a Workstation")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                $setup.filteredUserAllWorkStation.length > 0 ||
                $setup.WorkStationInvitation.length > 0
              )
                    ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                        ($setup.WorkStationInvitation && $setup.WorkStationInvitation.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.WorkStationInvitation, (member, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "tw-justify-between tw-flex-col ws-items-bg tw-w-full tw-flex tw-items-start tw-p-4 tw-rounded-[6px]"
                                }, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, _toDisplayString(member?.userRole?.id === 2
                          ? "Property owner"
                          : member?.userRole?.id === 3
                          ? "Sole trader"
                          : ""), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    ($setup.InviteMemberImage)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "ws-profile-logo tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-min-w-[56px] tw-h-[56px] tw-relative tw-object-cover",
                                          src: $setup.InviteMemberImage
                                        }, null, 8, _hoisted_34))
                                      : (_openBlock(), _createBlock(_component_WorkStationProfileLogo, {
                                          key: 1,
                                          class: "tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-h-[56px] tw-relative",
                                          WSName: member?.userWorkstation?.name
                                        }, null, 8, ["WSName"])),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                          _createVNode(_component_Text, {
                                            variant: "h6",
                                            isCapitalize: true
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(member?.userWorkstation?.name), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("div", _hoisted_39, _toDisplayString(member?.role), 1)
                                          ])
                                        ]),
                                        (member?.tags)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseJSON(member?.tags), (tag) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "tw-flex",
                                                  key: tag
                                                }, [
                                                  _createElementVNode("div", _hoisted_41, _toDisplayString(tag), 1)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_42, [
                                          _createElementVNode("div", _hoisted_43, [
                                            _createVNode(_component_Text, {
                                              variant: "span",
                                              textWeight: "600",
                                              textColor: "rgba(12, 15, 74, 0.5)"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(member?.user?.email), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          (member?.message)
                                            ? (_openBlock(), _createBlock(_component_Text, {
                                                key: 0,
                                                variant: "span",
                                                textWeight: "600",
                                                textColor: "rgba(12, 15, 74, 0.5)"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(member?.message), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_Text, {
                                            class: "!tw-text-[10px] md:!tw-text-[11px] !tw-leading-none !tw-text-darkBlue/50",
                                            textWeight: "400"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Last signed in: " + _toDisplayString(member?.lastLoginAt
                                ? $setup.formatDate(member?.lastLoginAt, "fullDate")
                                : "Not Signed"), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      (
                          member?.invitationStatus ===
                          $setup.MemberInvitationStatusEnum.PENDING
                        )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createVNode(_component_v_btn, {
                                              class: "tw-px-[8px] tw-py-[6px] md:tw-py-[10px] tw-box-border tw-rounded-[6px] tw-text-[12px] tw-flex tw-gap-3 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-bold tw-capitalize !tw-h-[auto] tw-leading-none tw-shadow-none",
                                              onClick: ($event: any) => ($setup.onOpenConfirmRejectModal(member?.id))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_InfoIconWhite),
                                                _hoisted_45
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_btn, {
                                              loading: 
                            $setup.acceptInvitationLoader &&
                            $setup.acceptInvitationWorkstationId === member?.token
                          ,
                                              class: "tw-px-[8px] tw-py-[6px] md:tw-py-[10px] tw-box-border tw-rounded-[6px] tw-text-[12px] tw-flex tw-gap-3 tw-items-center tw-justify-center tw-bg-[#1FB27A] tw-text-white tw-font-bold tw-capitalize !tw-h-[auto] tw-leading-none tw-shadow-none",
                                              onClick: ($event: any) => ($setup.onClickAcceptWSInvitation(member?.token))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_CheckIconWhite),
                                                _hoisted_46
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "onClick"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                          member?.invitationStatus ===
                          $setup.MemberInvitationStatusEnum.ACCEPTED
                        )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                            _createVNode(_component_NotificationIcon),
                                            _createVNode(_component_v_btn, {
                                              class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#4B4BFF] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                              onClick: ($event: any) => (
                            $setup.onWorkStationClick(member?.userWorkstation?.id)
                          )
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" launch "),
                                                _createVNode(_component_LunchIcon, { class: "tw-ml-2" })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_btn, {
                                              class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                              onClick: ($event: any) => ($setup.onClickRejectWSInvitation(member?.id))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Delete "),
                                                _createVNode(_component_TrashIcon, {
                                                  class: "tw-ml-2",
                                                  fill: "#FFF",
                                                  fillOpacity: "1"
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createElementVNode("div", _hoisted_48, [
                                              _createVNode(_component_DeleteActionChip, {
                                                onClick: ($event: any) => ($setup.onClickRejectWSInvitation(member?.id))
                                              }, null, 8, ["onClick"])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredUserAllWorkStation, (member, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (index < $setup.numberOfWsShowed)
                                ? (_openBlock(), _createElementBlock("div", {
                                    class: "tw-justify-between tw-flex-col ws-items-bg tw-w-full tw-flex tw-items-start tw-p-4 tw-rounded-[6px]",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, _toDisplayString(member?.userRole?.id === 2
                            ? "Property owner"
                            : member?.userRole?.id === 3
                            ? "Sole trader"
                            : ""), 1),
                                      _createElementVNode("div", _hoisted_52, [
                                        _createVNode(_component_NotificationIcon),
                                        ($setup.workStationNotificationCount[member?.id])
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                                              _createVNode(_component_Text, { variant: "xsmall" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.workStationNotificationCount[member?.id] || 0), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_btn, {
                                          class: "tw-px-4 md:tw-px-2 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#4B4BFF] tw-text-white tw-font-medium tw-capitalize tw-text-sm md:tw-text-[11px] !tw-h-[auto] tw-leading-5",
                                          onClick: ($event: any) => ($setup.onWorkStationClick(member?.id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" launch "),
                                            _createVNode(_component_LunchIcon, { class: "tw-ml-2" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        (member?.isInvited)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              loading: 
                            $setup.deleteInvitedWorkstationLoader &&
                            $setup.deleteInvitedWorkstationId === member?.memberId
                          ,
                                              class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5 md:tw-hidden",
                                              onClick: ($event: any) => ($setup.onClickRejectWSInvitation(member?.memberId))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Delete "),
                                                _createVNode(_component_TrashIcon, {
                                                  class: "tw-ml-2",
                                                  fill: "#FFF",
                                                  fillOpacity: "1"
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      (member?.imageUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: member?.imageUrl,
                                            class: "ws-profile-logo tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-min-w-[56px] tw-h-[56px] tw-relative tw-object-cover"
                                          }, null, 8, _hoisted_55))
                                        : (_openBlock(), _createBlock(_component_WorkStationProfileLogo, {
                                            key: 1,
                                            class: "tw-rounded-full tw-overflow-hidden tw-w-[56px] tw-h-[56px] tw-relative",
                                            WSName: member?.name
                                          }, null, 8, ["WSName"])),
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("div", _hoisted_57, [
                                          _createElementVNode("div", _hoisted_58, [
                                            _createVNode(_component_Text, {
                                              variant: "h6",
                                              class: "!tw-capitalize"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(member?.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            (member?.role)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                  _createVNode(_component_Text, {
                                                    variant: "p",
                                                    textWeight: "400"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(member?.role), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                  _createVNode(_component_Text, {
                                                    variant: "p",
                                                    textWeight: "400"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("Admin")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                          ]),
                                          (member?.tags)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseJSON(member?.tags), (tag) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "tw-flex",
                                                    key: tag
                                                  }, [
                                                    _createElementVNode("div", _hoisted_62, _toDisplayString(tag), 1)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_63, [
                                            _hoisted_64,
                                            (member?.message)
                                              ? (_openBlock(), _createBlock(_component_Text, {
                                                  key: 0,
                                                  variant: "span",
                                                  textWeight: "600",
                                                  textColor: "rgba(12, 15, 74, 0.5)"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(member?.message), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_Text, {
                                              class: "!tw-text-[10px] md:!tw-text-[11px] !tw-leading-none !tw-text-darkBlue/50",
                                              textWeight: "400"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Last signed in: " + _toDisplayString(member?.lastLoginAt
                                  ? $setup.formatDate(member?.lastLoginAt, "fullDate")
                                  : "Not Signed"), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_65, [
                                          _createVNode(_component_NotificationIcon),
                                          ($setup.workStationNotificationCount[member?.id])
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                                                _createVNode(_component_Text, { variant: "xsmall" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.workStationNotificationCount[member?.id] || 0), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_btn, {
                                            class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#4B4BFF] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                            onClick: ($event: any) => ($setup.onWorkStationClick(member?.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" launch "),
                                              _createVNode(_component_LunchIcon, { class: "tw-ml-2" })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          (member?.isInvited)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                loading: 
                              $setup.deleteInvitedWorkstationLoader &&
                              $setup.deleteInvitedWorkstationId === member?.memberId
                            ,
                                                class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                                onClick: ($event: any) => ($setup.onClickRejectWSInvitation(member?.memberId))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Delete "),
                                                  _createVNode(_component_TrashIcon, {
                                                    class: "tw-ml-2",
                                                    fill: "#FFF",
                                                    fillOpacity: "1"
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["loading", "onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      (member?.isInvited)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            loading: 
                          $setup.deleteInvitedWorkstationLoader &&
                          $setup.deleteInvitedWorkstationId === member?.memberId
                        ,
                                            class: "tw-px-4 tw-py-2 tw-box-border tw-rounded tw-flex tw-gap-2 tw-items-center tw-justify-center tw-bg-[#F45454] tw-text-white tw-font-medium tw-capitalize tw-text-sm !tw-h-[auto] tw-leading-5",
                                            onClick: ($event: any) => ($setup.onClickRejectWSInvitation(member?.memberId))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Delete "),
                                              _createVNode(_component_TrashIcon, {
                                                class: "tw-ml-2",
                                                fill: "#FFF",
                                                fillOpacity: "1"
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["loading", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          ($setup.filteredUserAllWorkStation?.length > 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                (!$setup.isShowAllws)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer",
                                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.toggleShowWs && $setup.toggleShowWs(...args)))
                                    }, [
                                      _createVNode(_component_Text, {
                                        textWeight: "600",
                                        variant: "h6",
                                        textColor: "rgba(12, 15, 74, 0.5)"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("See " + _toDisplayString(`${$setup.filteredUserAllWorkStation?.length - 3}`) + " more workstation", 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-chevron-down",
                                        color: "rgba(12, 15, 74, 0.5)"
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                ($setup.isShowAllws)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer",
                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.toggleShowWs && $setup.toggleShowWs(...args)))
                                    }, [
                                      _createVNode(_component_Text, {
                                        textWeight: "600",
                                        variant: "p",
                                        textColor: "rgba(12, 15, 74, 0.5)"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("See less workstation")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-chevron-up",
                                        color: "rgba(12, 15, 74, 0.5)"
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Button, {
                            class: "!tw-w-auto tw-box-border !tw-text-[#FFA500]",
                            variant: "custom",
                            onClick: $setup.onClickToggleTradesWorkStation,
                            label: "Create a new workstation",
                            activeBgColor: "transparent",
                            width: "auto",
                            isCapitalize: true,
                            fontWeight: 700
                          }, {
                            postfix: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-chevron-right",
                                color: "#FFA500"
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("section", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_Text, {
                            variant: "h3",
                            class: "md:!tw-text-[20px]",
                            whiteSpace: "nowrap"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Getting started with iknowa")
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-check-circle",
                                  color: "#264FD5"
                                }),
                                _createVNode(_component_Text, {
                                  variant: "span",
                                  textColor: "#264FD5"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Completed")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_Text, {
                                variant: "h5",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Sign up to iknowa")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Text, {
                                variant: "h6",
                                textWeight: "400"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("You’ve just signed up to"),
                                  _hoisted_75,
                                  _createTextVNode(" iknowa via a link from NWG.")
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("img", {
                              class: "tw-hidden rlg:!tw-flex",
                              src: require('@/assets/images/up-next-desktop.svg'),
                              alt: ""
                            }, null, 8, _hoisted_76),
                            _createElementVNode("img", {
                              class: "tw-flex rlg:!tw-hidden",
                              src: require('@/assets/images/up-next-mobile.svg'),
                              alt: ""
                            }, null, 8, _hoisted_77)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("img", {
                            class: "tw-w-[200px]",
                            src: require('@/assets/images/tp-banner.svg'),
                            alt: "iknowa banner"
                          }, null, 8, _hoisted_79),
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_Text, { variant: "h5" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Create your trade workstation")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Text, {
                              variant: "h6",
                              textWeight: "400"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Unlock access to subsidised upskilling courses, estimate new job opportunities, and seamlessly collaborate.")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Button, {
                              class: "!tw-w-auto",
                              label: 
                      $setup.filteredUserAllWorkStation &&
                      $setup.filteredUserAllWorkStation.lenght
                        ? 'CREATE A new WORKSTATION'
                        : 'CREATE A TRADE WORKSTATION'
                    ,
                              variant: "accent",
                              onClick: $setup.onClickToggleTradesWorkStation
                            }, null, 8, ["label", "onClick"]),
                            _createVNode(_component_Text, {
                              variant: "span",
                              textWeight: "400",
                              textColor: "rgba(12, 15, 74, 0.5)",
                              lineHeight: "18px"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Starting from £7.99 + VAT / monthly")
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                ])
              ]),
              _: 1
            }, 8, ["class", "isRoundedxl"]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_component_Card, {
                  class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4",
                  withBorder: true,
                  isRoundedxl: true
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("section", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("img", {
                            class: "!tw-w-[239px] tw-pb-4",
                            src: require('@/assets/images/courses-welcome.png')
                          }, null, 8, _hoisted_86),
                          _createVNode(_component_Text, { class: "!tw-text-[22px]" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Access Government subsidised Up-skilling courses")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Text, {
                            variant: "h6",
                            textWeight: "400"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("We’re serious about increasing the number of qualified installers.")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_87, [
                          ($setup.getCourseloading)
                            ? (_openBlock(), _createBlock(_component_CommonLoader, {
                                key: 0,
                                loading: $setup.getCourseloading,
                                class: "loader-container"
                              }, null, 8, ["loading"]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.coursesWithExtraInfo, (items) => {
                                return (_openBlock(), _createBlock(_component_Card, {
                                  key: items?.id,
                                  withBorder: true,
                                  isRoundedxl: true,
                                  class: "!tw-rounded-[16px] tw-px-4 tw-py-5 tw-box-border !tw-min-h-[332px] !tw-h-[332px] !tw-w-full"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_88, [
                                      _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("div", _hoisted_90, [
                                          _createElementVNode("img", {
                                            class: "tw-w-full tw-h-full tw-object-cover",
                                            src: 
                                    require('@/assets/images/course/' +
                                      items?.thumbnail)
                                  
                                          }, null, 8, _hoisted_91)
                                        ]),
                                        _createVNode(_component_Text, { variant: "h5" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(items?.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (
                                  items?.title ===
                                  'Solar PV, Battery Storage & EV Charging Level 3'
                                )
                                          ? (_openBlock(), _createBlock(_component_Text, {
                                              key: 0,
                                              variant: "span",
                                              textWeight: "400",
                                              textColor: "rgba(12, 15, 74, 0.5)",
                                              lineHeight: "18px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Designed for experienced Electrical"),
                                                _hoisted_92,
                                                _createTextVNode(" Engineers.")
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_Text, {
                                              key: 1,
                                              variant: "span",
                                              textWeight: "400",
                                              textColor: "rgba(12, 15, 74, 0.5)",
                                              lineHeight: "18px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Designed for experienced Plumbing & Heating Engineers.")
                                              ]),
                                              _: 1
                                            })),
                                        _createElementVNode("div", _hoisted_93, [
                                          _createVNode(_component_MapMarkerBlueIcon, { class: "tw-min-w-[11px] tw-min-h-[13px]" }),
                                          _createVNode(_component_Text, {
                                            variant: "span",
                                            textColor: "rgba(12, 15, 74, 0.5)"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("In-Person & E-Learning")
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createVNode(_component_Button, {
                                        variant: "secondary",
                                        label: "view course details",
                                        onClick: ($event: any) => ($setup.viewCourseDetails(items?.id))
                                      }, null, 8, ["onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4",
                  withBorder: true,
                  isRoundedxl: true
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("section", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_component_Text, { class: "!tw-text-[22px]" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Manage emails")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createElementVNode("div", _hoisted_100, [
                                _createVNode(_component_Text, {
                                  variant: "xsmall",
                                  textWeight: "700",
                                  textColor: "#4F55F0"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Primary")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_Text, {
                                variant: "p",
                                textWeight: "400"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.userEmail), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.manageEmailList, (email) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-border-0 tw-pb-2 !tw-gap-[.3rem] s540:!tw-flex-col",
                              key: email.id
                            }, [
                              _createElementVNode("div", _hoisted_101, [
                                (email?.invitationStatus === 'accepted')
                                  ? (_openBlock(), _createBlock(_component_ApproveChip, { key: 0 }))
                                  : _createCommentVNode("", true),
                                (email?.invitationStatus === 'pending')
                                  ? (_openBlock(), _createBlock(_component_PendingChip, { key: 1 }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_Text, {
                                  variant: "p",
                                  textWeight: "400"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(email?.aliasEmail), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_102, [
                                _createVNode(_component_DeleteActionChip, {
                                  onClick: ($event: any) => ($setup.onClickDeleteEmail(email))
                                }, null, 8, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _createVNode(_component_Button, {
                          class: "!tw-w-auto tw-box-border !tw-text-[#FFA500]",
                          variant: "custom",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleAddEmailModal(true))),
                          label: "Add Email Address",
                          activeBgColor: "transparent",
                          width: "auto",
                          isCapitalize: true,
                          fontWeight: 700
                        }, {
                          postfix: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              icon: "mdi-chevron-right",
                              color: "#FFA500"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_Card, {
                  class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4",
                  withBorder: true,
                  isRoundedxl: true
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("section", _hoisted_105, [
                      _createElementVNode("img", {
                        class: "!tw-w-[124px]",
                        src: require('@/assets/images/upcoming-events.svg')
                      }, null, 8, _hoisted_106),
                      _createElementVNode("section", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _createElementVNode("div", _hoisted_109, [
                            _createVNode(_component_Text, { class: "!tw-text-[22px]" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Stay tuned for more events in 2025")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Text, {
                              variant: "h6",
                              textWeight: "400"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Join us and connect with peers, gain insights from experts, and take steps towards advancing your career in the trade industry.")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_110, [
                            _createVNode(_component_Card, {
                              withBorder: true,
                              isRoundedxl: true,
                              class: "!tw-rounded-[16px] tw-px-4 tw-py-5 tw-box-border !tw-min-h-[332px] !tw-w-full"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_111, [
                                  _createElementVNode("div", _hoisted_112, [
                                    _createElementVNode("div", _hoisted_113, [
                                      _createElementVNode("img", {
                                        class: "tw-w-full tw-h-full tw-object-cover",
                                        src: 
                                    require('@/assets/images/iknowa-google-event.jpg')
                                  
                                      }, null, 8, _hoisted_114)
                                    ]),
                                    _createVNode(_component_Text, { variant: "h5" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("iknowa ‘Trade Community’ Event 2024")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Text, {
                                      variant: "span",
                                      textWeight: "400",
                                      textColor: "rgba(12, 15, 74, 0.5)",
                                      lineHeight: "18px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("iknowa and Google present an exclusive Trade Community event, uniting the UK's top retrofit professionals and industry leaders. ")
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_115, [
                                      _createElementVNode("div", _hoisted_116, [
                                        _createVNode(_component_CalendarIcon, { class: "tw-min-w-[11px] tw-min-h-[13px]" }),
                                        _createVNode(_component_Text, {
                                          variant: "span",
                                          textColor: "rgba(12, 15, 74, 0.5)"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("December 10, 2024")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_117, [
                                        _createVNode(_component_MapMarkerBlueIcon, { class: "tw-min-w-[11px] tw-min-h-[13px]" }),
                                        _createVNode(_component_Text, {
                                          variant: "span",
                                          textColor: "rgba(12, 15, 74, 0.5)"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("In-Person & E-Learning")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_118, [
                                        _createVNode(_component_MapMarkerYellowIcon, { class: "tw-min-w-[11px] tw-min-h-[13px]" }),
                                        _createVNode(_component_Text, {
                                          variant: "span",
                                          textColor: "rgba(12, 15, 74, 0.5)"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("London, W12 BM0")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]),
                                  _createVNode(_component_Button, {
                                    variant: "secondary",
                                    label: "join event",
                                    onClick: $setup.onClickViewGoogleEvent
                                  }, null, 8, ["onClick"])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, {
                  class: "!tw-max-h-[unset] tw-w-full tw-box-border tw-p-6 md:tw-p-4",
                  withBorder: true,
                  isRoundedxl: true
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("section", _hoisted_119, [
                      _createElementVNode("img", {
                        class: "!tw-w-[124px]",
                        src: require('@/assets/images/iknowa-benefits.png')
                      }, null, 8, _hoisted_120),
                      _createElementVNode("section", _hoisted_121, [
                        _createElementVNode("div", _hoisted_122, [
                          _createElementVNode("div", _hoisted_123, [
                            _createVNode(_component_Text, { class: "!tw-text-[22px]" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Learn more about iknowa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Text, {
                              variant: "h6",
                              textWeight: "400"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Explore everything that the iknowa can do.")
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_124
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _createVNode(_component_Button, {
                            class: "!tw-w-auto tw-box-border !tw-text-[#FFA500]",
                            variant: "custom",
                            onClick: $setup.onClickBenefitsButton,
                            label: "Explore iknowa benefits",
                            activeBgColor: "transparent",
                            width: "auto",
                            isCapitalize: true,
                            fontWeight: 700
                          }, {
                            postfix: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-chevron-right",
                                color: "#FFA500"
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!$setup.isUserWorkstationIsDefault && !$setup.isWorkstationLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_126, [
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                (
              $setup.activeUserWorkstation?.verificationStatus !==
                $setup.UserVerificationStatusEnum.VERIFIED &&
              $setup.accountStatuses?.forms?.insurance !== 0 &&
              $setup.accountStatuses?.forms?.certification !== 0 &&
              $setup.accountStatuses?.forms?.skills !== 0
            )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClickCapture: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.handleClick && $setup.handleClick(...args)))
                    }, [
                      _createVNode(_component_v_col, { class: "dashboard-setting-up__right tw-w-full !tw-p-0 tw-relative !tw-border-[1px] !tw-border-solid !tw-border-[#dfdfdf] !tw-rounded-[16px] tw-overflow-hidden" }, {
                        default: _withCtx(() => [
                          (
                  $setup.userWorkStationStatus ===
                    $setup.UserVerificationStatusEnum.PENDING_VERIFICATION &&
                  !$setup.isWorkstationLoading
                )
                            ? (_openBlock(), _createBlock(_component_WorkStationVerificationProgress, { key: 0 }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_card, {
                            class: _normalizeClass(["custom-card tw-relative", {
                  'fixed-height':
                    $setup.userWorkStationStatus ===
                    $setup.UserVerificationStatusEnum.VERIFIED,
                }])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, [
                                  _createVNode(_component_v_icon, { icon: "mdi-star" }),
                                  _hoisted_131
                                ]),
                                _createVNode(_component_Text, {
                                  variant: "p",
                                  textColor: "rgba(12, 15, 74, 0.5)",
                                  textWeight: "400"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Complete the below steps to activate your workstation!")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("div", _hoisted_133, [
                                  _hoisted_134,
                                  _createElementVNode("span", null, _toDisplayString($setup.workstationSetupProgressNew) + " % ", 1)
                                ]),
                                _createVNode(_component_v_progress_linear, {
                                  color: "#40AE42",
                                  "model-value": $setup.workstationSetupProgressNew,
                                  height: "8",
                                  rounded: ""
                                }, null, 8, ["model-value"])
                              ]),
                              _createElementVNode("div", _hoisted_135, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["progress-list__item", {
                      completed: !$setup.isUserWorkstationIsDefault,
                    }])
                                }, _hoisted_138, 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["progress-list__item", {
                      completed: $setup.isUserAddBusinessAddress,
                    }]),
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.onClickAddBusinessAddressModal && $setup.onClickAddBusinessAddressModal(...args)))
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progress-list__counter", {
                        '!tw-bg-[#0C0F4A]': !$setup.isUserAddBusinessAddress,
                      }])
                                  }, _hoisted_140, 2),
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("p", {
                                      class: _normalizeClass(["common-title", {
                          '!tw-text-[#4B4BFF]': !$setup.isUserAddBusinessAddress,
                        }])
                                    }, " Add Business Address ", 2),
                                    _hoisted_142
                                  ])
                                ], 2),
                                (
                      $setup.userBusinessType ===
                      $setup.BusinessDetailTypeEnum.LIMITED_COMPANY
                    )
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["progress-list__item", {
                      completed:
                        $setup.WorkStationSiltVerificationStatus &&
                        ['SUCCESS', 'MANUAL_REVIEW'].includes(
                          $setup.WorkStationSiltVerificationStatus?.status
                        ),
                    }]),
                                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.onClickIDVerificationModal && $setup.onClickIDVerificationModal(...args)))
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["progress-list__counter", {
                        '!tw-bg-[#0C0F4A]': !(
                          $setup.WorkStationSiltVerificationStatus &&
                          ['SUCCESS', 'MANUAL_REVIEW'].includes(
                            $setup.WorkStationSiltVerificationStatus?.status
                          )
                        ),
                      }])
                                      }, _hoisted_144, 2),
                                      _createElementVNode("div", _hoisted_145, [
                                        _createElementVNode("p", {
                                          class: _normalizeClass(["common-title", {
                          '!tw-text-[#4B4BFF]': !(
                            $setup.WorkStationSiltVerificationStatus &&
                            ['SUCCESS', 'MANUAL_REVIEW'].includes(
                              $setup.WorkStationSiltVerificationStatus?.status
                            )
                          ),
                        }])
                                        }, " Complete ID & Business Verification ", 2),
                                        _hoisted_146
                                      ])
                                    ], 2))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(["progress-list__item", {
                      completed: [
                        $setup.UserVerificationStatusEnum.VERIFIED,
                        $setup.UserVerificationStatusEnum.PENDING_VERIFICATION,
                      ].includes(
                        $setup.activeUserWorkstation?.user?.userKYCVerificationStatus
                      ),
                    }]),
                                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.onClickIDVerificationModal && $setup.onClickIDVerificationModal(...args)))
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["progress-list__counter", {
                        '!tw-bg-[#0C0F4A]': ![
                          $setup.UserVerificationStatusEnum.VERIFIED,
                          $setup.UserVerificationStatusEnum.PENDING_VERIFICATION,
                        ].includes(
                          $setup.activeUserWorkstation?.user?.userKYCVerificationStatus
                        ),
                      }])
                                      }, _hoisted_148, 2),
                                      _createElementVNode("div", _hoisted_149, [
                                        _createElementVNode("p", {
                                          class: _normalizeClass(["common-title", {
                          '!tw-text-[#4B4BFF]': ![
                            $setup.UserVerificationStatusEnum.VERIFIED,
                            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION,
                          ].includes(
                            $setup.activeUserWorkstation?.user
                              ?.userKYCVerificationStatus
                          ),
                        }])
                                        }, " Complete ID Verification ", 2),
                                        _hoisted_150
                                      ])
                                    ], 2)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["progress-list__item", {
                      completed: $setup.isUserProfileVerified,
                    }]),
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.onClickManageTradePassportPreviewModal && $setup.onClickManageTradePassportPreviewModal(...args)))
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progress-list__counter", { '!tw-bg-[#0C0F4A]': !$setup.isUserProfileVerified }])
                                  }, _hoisted_152, 2),
                                  _createElementVNode("div", _hoisted_153, [
                                    _createElementVNode("p", {
                                      class: _normalizeClass(["common-title", {
                          '!tw-text-[#4B4BFF]': !$setup.isUserProfileVerified,
                        }])
                                    }, " Complete Your Trade Passport ", 2),
                                    _hoisted_154
                                  ])
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["progress-list__item", {
                      completed:
                        $setup.userWorkStationStatus ===
                          $setup.UserVerificationStatusEnum.PENDING_VERIFICATION ||
                        $setup.userWorkStationStatus ===
                          $setup.UserVerificationStatusEnum.VERIFIED,
                    }]),
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.onClickSubmitVerificationPreviewModal && $setup.onClickSubmitVerificationPreviewModal(...args)))
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progress-list__counter", {
                        '!tw-bg-[#0C0F4A]': !(
                          $setup.userWorkStationStatus ===
                            $setup.UserVerificationStatusEnum.PENDING_VERIFICATION ||
                          $setup.userWorkStationStatus ===
                            $setup.UserVerificationStatusEnum.VERIFIED
                        ),
                      }])
                                  }, _hoisted_156, 2),
                                  _createElementVNode("div", _hoisted_157, [
                                    _createElementVNode("p", {
                                      class: _normalizeClass(["common-title", {
                          '!tw-text-[#4B4BFF]': !(
                            $setup.userWorkStationStatus ===
                              $setup.UserVerificationStatusEnum.PENDING_VERIFICATION ||
                            $setup.userWorkStationStatus ===
                              $setup.UserVerificationStatusEnum.VERIFIED
                          ),
                        }])
                                    }, " Submit Your Workstation for Verification ", 2),
                                    _hoisted_158
                                  ])
                                ], 2),
                                _createElementVNode("div", _hoisted_159, [
                                  (
                        $setup.userWorkStationStatus !==
                        $setup.UserVerificationStatusEnum.VERIFIED
                      )
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        isLoading: $setup.onSubmitVerification,
                                        isActive: 
                        $setup.isUserProfileVerified &&
                        $setup.userWorkStationStatus !==
                          $setup.UserVerificationStatusEnum.PENDING_VERIFICATION &&
                        $setup.isUserAddBusinessAddress
                      ,
                                        label: 
                        $setup.userWorkStationStatus ===
                        $setup.UserVerificationStatusEnum.PENDING_VERIFICATION
                          ? 'profile verification submitted'
                          : 'submit for verification'
                      ,
                                        class: "!tw-w-[auto] !tw-max-w-[auto] md:!tw-w-full",
                                        onClick: $setup.onClickSubmitVerification
                                      }, null, 8, ["isLoading", "isActive", "label", "onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 1
                      })
                    ], 32))
                  : _createCommentVNode("", true),
                (
              !(
                $setup.activeUserWorkstation?.verificationStatus !==
                  $setup.UserVerificationStatusEnum.VERIFIED &&
                $setup.accountStatuses?.forms?.insurance !== 0 &&
                $setup.accountStatuses?.forms?.certification !== 0 &&
                $setup.accountStatuses?.forms?.skills !== 0
              )
            )
                  ? (_openBlock(), _createBlock(_component_JobsOverviewWidget, {
                      key: 1,
                      getUserWorkStationFieldAccess: $setup.getUserWorkStationFieldAccess
                    }, null, 8, ["getUserWorkStationFieldAccess"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_TeamWidget, {
                  className: "!tw-min-h-[229px]",
                  getUserWorkStationFieldAccess: $setup.isUserWorkStationAdmin,
                  propMembers: $setup.members,
                  onGetMembers: $setup.getTeamMember
                }, null, 8, ["getUserWorkStationFieldAccess", "propMembers", "onGetMembers"]),
                _createVNode(_component_TradeNetworkWidget, { getUserWorkStationFieldAccess: $setup.getUserWorkStationFieldAccess }, null, 8, ["getUserWorkStationFieldAccess"])
              ]),
              _createElementVNode("div", _hoisted_160, [
                (
              $setup.activeUserWorkstation?.verificationStatus !==
                $setup.UserVerificationStatusEnum.VERIFIED &&
              $setup.accountStatuses?.forms?.insurance !== 0 &&
              $setup.accountStatuses?.forms?.certification !== 0 &&
              $setup.accountStatuses?.forms?.skills !== 0
            )
                  ? (_openBlock(), _createBlock(_component_JobsOverviewWidget, {
                      key: 0,
                      getUserWorkStationFieldAccess: $setup.getUserWorkStationFieldAccess
                    }, null, 8, ["getUserWorkStationFieldAccess"]))
                  : _createCommentVNode("", true),
                (
              $setup.activeUserWorkstation?.verificationStatus !==
                $setup.UserVerificationStatusEnum.VERIFIED &&
              $setup.accountStatuses?.forms?.insurance !== 0 &&
              $setup.accountStatuses?.forms?.certification !== 0 &&
              $setup.accountStatuses?.forms?.skills !== 0
            )
                  ? (_openBlock(), _createBlock(_component_CalendarEventWidget, {
                      key: 1,
                      getUserWorkStationFieldAccess: $setup.getUserWorkStationFieldAccess,
                      userWorkStationImage: $setup.userWorkStationImage,
                      calenderAttribute: $setup.calenderAttribute,
                      className: "tw-max-h-[758px] tw-overflow-hidden tw-rounded-lg tw-h-full"
                    }, null, 8, ["getUserWorkStationFieldAccess", "userWorkStationImage", "calenderAttribute"]))
                  : (_openBlock(), _createBlock(_component_CalendarEventWidget, {
                      key: 2,
                      getUserWorkStationFieldAccess: $setup.getUserWorkStationFieldAccess,
                      userWorkStationImage: $setup.userWorkStationImage,
                      calenderAttribute: $setup.calenderAttribute,
                      className: "!tw-h-full"
                    }, null, 8, ["getUserWorkStationFieldAccess", "userWorkStationImage", "calenderAttribute"]))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        width: "350px",
        modelValue: $setup.launchInvitedWorkstation,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.launchInvitedWorkstation) = $event)),
        class: "modal_box action-modal",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_161, [
            _createElementVNode("main", _hoisted_162, [
              _createElementVNode("div", null, [
                _hoisted_163,
                _createElementVNode("p", _hoisted_164, _toDisplayString($setup.switchingText), 1),
                _createVNode(_component_v_stepper, {
                  class: "onboard-stepper",
                  modelValue: $setup.currentSelectedTab.name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.currentSelectedTab.name) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabListItems, (step, index) => {
                          return (_openBlock(), _createBlock(_component_v_stepper_item, {
                            class: "onboard-stepper__item",
                            key: index,
                            value: step.name
                          }, null, 8, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2),
    ($setup.isShowAddEmailModal)
      ? (_openBlock(), _createBlock(_component_AddEmailModal, {
          key: 0,
          onOnClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.toggleAddEmailModal($event))),
          onOnClickAdd: $setup.onClickAddEmail
        }, null, 8, ["onOnClickAdd"]))
      : _createCommentVNode("", true),
    ($setup.isShowAddEmailConformModal)
      ? (_openBlock(), _createBlock(_component_EmailConformModal, {
          key: 1,
          modalType: $setup.emailConfirmModalType,
          manageEmail: $setup.manageEmail,
          onOnClose: $setup.toggleAddEmailConfirmModal
        }, null, 8, ["modalType", "manageEmail", "onOnClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: $setup.isShowWorkStationModal,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.isShowWorkStationModal) = $event)),
      width: "968px",
      class: "custom__modal__box soletrader__modal__box",
      height: "836px",
      "max-width": "100%",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_165, [
          _createVNode(_component_v_btn, {
            variant: "text",
            "aria-label": "Refresh",
            class: "back_btn",
            "prepend-icon": "mdi-chevron-left",
            onClick: $setup.onClickToggleTradesWorkStation
          }, {
            default: _withCtx(() => [
              _createTextVNode("back")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("main", _hoisted_166, [
          _hoisted_167,
          _createElementVNode("div", _hoisted_168, [
            _createElementVNode("div", _hoisted_169, [
              _createElementVNode("div", _hoisted_170, [
                _createTextVNode(" Great job, "),
                _createElementVNode("span", _hoisted_171, _toDisplayString($setup.userName), 1),
                _createTextVNode(),
                _hoisted_172,
                _createTextVNode(" You are a step closer in creating your Trade Workstation! ")
              ]),
              _createVNode(_component_Text, {
                variant: "h6",
                textWeight: "400",
                textColor: "rgba(12, 15, 74, 0.5)",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("So we can personalise your Workstation, please tell us what type of business do you have.")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_173, [
              _createVNode(_component_v_card, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.onClickSoleTrader())),
                class: "modal_card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_174, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _hoisted_175
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_176
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.onClickLimitedCompany())),
                class: "modal_card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_177, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _hoisted_178
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_179
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    ($setup.isShowSoleTraderWorkStation)
      ? (_openBlock(), _createBlock(_component_SoleTraderWorkStationComponent, {
          key: 2,
          onOnClickCloseTab: $setup.onClickCloseSoloTrader,
          onOnLaunchTpWorkstation: _cache[17] || (_cache[17] = ($event: any) => ($setup.onWorkStationClick($event)))
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowLimitedCompanyWorkStation)
      ? (_openBlock(), _createBlock(_component_LimitedCompanyWorkStationComponent, {
          key: 3,
          onOnClickCloseTab: $setup.onClickCloseLimitedCompany,
          onOnLaunchTpWorkstation: _cache[18] || (_cache[18] = ($event: any) => ($setup.onWorkStationClick($event)))
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.INSURANCE)
      ? (_openBlock(), _createBlock(_component_InsuranceModel, {
          key: 4,
          onOnClickCloseTab: $setup.onClickCloseModel,
          isOuterEditInsurance: $setup.isOuterEditInsurance,
          userInsuranceData: $setup.userInsuranceData,
          onClearUserInsuranceData: $setup.clearData
        }, null, 8, ["onOnClickCloseTab", "isOuterEditInsurance", "userInsuranceData", "onClearUserInsuranceData"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.CERTIFICATION)
      ? (_openBlock(), _createBlock(_component_CertificationModal, {
          key: 5,
          userCertificateData: $setup.userCertificateData,
          onOnClickCloseTab: $setup.onClickCloseModel,
          onClearUserCertificateData: $setup.clearData
        }, null, 8, ["userCertificateData", "onOnClickCloseTab", "onClearUserCertificateData"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.TAXANDVAT)
      ? (_openBlock(), _createBlock(_component_TaxAndVatModel, {
          key: 6,
          mode: $setup.taxModalMode,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["mode", "onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.INVITEFORM)
      ? (_openBlock(), _createBlock(_component_InviteMemberForm, {
          key: 7,
          onCloseForm: $setup.onClickCloseModel
        }, null, 8, ["onCloseForm"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.VERIFYMODAL)
      ? (_openBlock(), _createBlock(_component_WorkstationVerificationModal, {
          key: 8,
          onClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowNewSubscriptionModal)
      ? (_openBlock(), _createBlock(_component_NewWorkstationSubscriptionModal, {
          key: 9,
          onOnClickPaymentPlan: $setup.onClickPaymentPlan,
          onCloseModal: $setup.toggleNewWorkstationSubscriptionModal,
          onOnClickTermsAndCondition: $setup.onClickTermsAndConditionModal
        }, null, 8, ["onOnClickPaymentPlan", "onCloseModal", "onOnClickTermsAndCondition"]))
      : _createCommentVNode("", true),
    ($setup.isShowUnlockFreeAccessModal)
      ? (_openBlock(), _createBlock(_component_UnlockFreeAccessModal, {
          key: 10,
          onOnClickUnlockFreeAccess: $setup.onClickUnlockFreeAccess,
          onClose: $setup.toggleUnlockFreeAccessModal
        }, null, 8, ["onOnClickUnlockFreeAccess", "onClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowStartIDVerificationModal)
      ? (_openBlock(), _createBlock(_component_StartIDVerificationModal, {
          key: 11,
          onOnClickStartIDVerification: $setup.onClickStartIDVerification,
          onClose: $setup.toggleStartIDVerificationModal
        }, null, 8, ["onOnClickStartIDVerification", "onClose"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.ADDRESSMODAL)
      ? (_openBlock(), _createBlock(_component_AddAddressModal, {
          key: 12,
          onOnCloseSuccess: $setup.onClickCloseModel,
          onOnClose: $setup.onClickCloseModel
        }, null, 8, ["onOnCloseSuccess", "onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.RATEMODAL)
      ? (_openBlock(), _createBlock(_component_AddUserRatesModal, {
          key: 13,
          onCloseUpdateUserRatesModal: $setup.onClickCloseModel
        }, null, 8, ["onCloseUpdateUserRatesModal"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.SPECIALISM)
      ? (_openBlock(), _createBlock(_component_SpecialismMultiSelectModel, {
          key: 14,
          onOnClickCancel: $setup.onClickCloseModel
        }, null, 8, ["onOnClickCancel"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === 'CreateTradeWSModal')
      ? (_openBlock(), _createBlock(_component_CreateTradeWSModal, {
          key: 15,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    (
      $setup.user.loginAttempt === 1 &&
      $setup.isShowWelcomeTradePersonPopup &&
      !$setup.route.query.courseReservation
    )
      ? (_openBlock(), _createBlock(_component_WelcomeTradePersonPopup, {
          key: 16,
          onOnClickExploreButton: $setup.onClickExploreButton
        }, null, 8, ["onOnClickExploreButton"]))
      : _createCommentVNode("", true),
    ($setup.isShowTradePersonBenefitsModal)
      ? (_openBlock(), _createBlock(_component_TradePersonBenefitsModal, {
          key: 17,
          onOnClickClosePreviewModalButton: $setup.onClickClosePreviewModalButton
        }, null, 8, ["onOnClickClosePreviewModalButton"]))
      : _createCommentVNode("", true),
    (
      $setup.openedModel === $setup.modelName.ADDBUSINESSADDRESSMODAL ||
      (!$setup.isUserWorkstationIsDefault &&
        $setup.showVerificationPrompType === $setup.BUSINESS_ADDRESS &&
        !$setup.closeAllVerificationPopupPrompt &&
        !$setup.isShowLimitedCompanyWorkStation &&
        !$setup.isShowSoleTraderWorkStation &&
        !$setup.isWorkstationLoading &&
        !$setup.loaderBuffer)
    )
      ? (_openBlock(), _createBlock(_component_AddBusinessAddressPreviewModal, {
          key: 18,
          onOnClickCloseTab: $setup.onClickCloseModel,
          onOnClickCloseSuccessTab: $setup.onClickCloseSuccessModal
        }, null, 8, ["onOnClickCloseTab", "onOnClickCloseSuccessTab"]))
      : _createCommentVNode("", true),
    (
      $setup.openedModel === $setup.modelName.VERIFYPREVIEWMODAL ||
      (!$setup.isUserWorkstationIsDefault &&
        $setup.showVerificationPrompType === $setup.ID_VERIFICATION &&
        !$setup.closeAllVerificationPopupPrompt &&
        !$setup.isShowLimitedCompanyWorkStation &&
        !$setup.isShowSoleTraderWorkStation &&
        !$setup.isWorkstationLoading &&
        !$setup.loaderBuffer)
    )
      ? (_openBlock(), _createBlock(_component_CompleteIDVerificationPreviewModal, {
          key: 19,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    (
      $setup.openedModel === $setup.modelName.TRADEPASSPORTPREVIEWMODAL ||
      (!$setup.isUserWorkstationIsDefault &&
        $setup.showVerificationPrompType === $setup.TRADE_PASSPORT &&
        !$setup.closeAllVerificationPopupPrompt &&
        !$setup.isShowLimitedCompanyWorkStation &&
        !$setup.isShowSoleTraderWorkStation &&
        !$setup.isWorkstationLoading &&
        !$setup.loaderBuffer)
    )
      ? (_openBlock(), _createBlock(_component_TradePassportPreviewModal, {
          key: 20,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    (
      $setup.openedModel === $setup.modelName.WORKSTATIONVERIFYPREVIEWMODAL ||
      (!$setup.isUserWorkstationIsDefault &&
        $setup.showVerificationPrompType === $setup.SUBMIT_WS &&
        !$setup.closeAllVerificationPopupPrompt &&
        !$setup.isShowLimitedCompanyWorkStation &&
        !$setup.isShowSoleTraderWorkStation &&
        !$setup.isWorkstationLoading &&
        !$setup.loaderBuffer)
    )
      ? (_openBlock(), _createBlock(_component_WorkstationForVerificationPreviewModal, {
          key: 21,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isOpenConfirmDelete)
      ? (_openBlock(), _createBlock(_component_ConfirmDeleteModal, {
          key: 22,
          type: $setup.confirmDeleteType,
          label: $setup.confirmDeleteLabel,
          onOnClose: $setup.onCloseConfirmDelete,
          onOnDelete: $setup.deleteItem
        }, null, 8, ["type", "label", "onOnClose", "onOnDelete"]))
      : _createCommentVNode("", true),
    ($setup.isShowBuySpotConfirmationModal)
      ? (_openBlock(), _createBlock(_component_BuySpotConfirmation, {
          key: 23,
          onOnClose: $setup.onCloseIsShowBuySpotConfirmationModal
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowUpgradeSubscriptionModal)
      ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
          key: 24,
          onOnClose: $setup.onCloseIsShowUpgradeSubscriptionModal,
          onOnUpgradeSuccess: $setup.onCourseUpdateSuccess,
          onOnUpgradeFail: $setup.onCourseUpdateFailed
        }, null, 8, ["onOnClose", "onOnUpgradeSuccess", "onOnUpgradeFail"]))
      : _createCommentVNode("", true),
    ($setup.isOpenPaymentStatusModal)
      ? (_openBlock(), _createBlock(_component_PaymentStatusModal, {
          key: 25,
          onContinue: $setup.onClosePamentStatusModal,
          paymentStatus: $setup.pamentStatus,
          planType: $setup.paymentType
        }, null, 8, ["onContinue", "paymentStatus", "planType"]))
      : _createCommentVNode("", true),
    ($setup.isShowHasSpotNotice)
      ? (_openBlock(), _createBlock(_component_HasSpotNotice, {
          key: 26,
          onOnClose: $setup.onCloseHasSpotNoticeModal
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowHasSpotReservedNotice)
      ? (_openBlock(), _createBlock(_component_HasReservedSpotNotice, {
          key: 27,
          onOnClose: $setup.onCloseHasSpotReserveNoticeModal
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isOpenAssignCourseSlotToMemberModal)
      ? (_openBlock(), _createBlock(_component_AssignCourseSlotToMemberModal, {
          key: 28,
          selectedUserCourseIdForAssign: $setup.selectedUserCourseIdForAssignMember,
          onOnClickCloseButton: $setup.toggleAssignCourseSlotToMemberModal,
          onMemberInvited: $setup.getTeamMember
        }, null, 8, ["selectedUserCourseIdForAssign", "onOnClickCloseButton", "onMemberInvited"]))
      : _createCommentVNode("", true),
    ($setup.isShowUpgradePremiumModal && !$setup.isPropertyOwner)
      ? (_openBlock(), _createBlock(_component_TpSubscriptionModal, {
          key: 29,
          onOnClickCloseTab: $setup.closeUpgradePremiumModal,
          onOnSuccessPayment: $setup.handleSubscriptionSuccess
        }, null, 8, ["onOnClickCloseTab", "onOnSuccessPayment"]))
      : _createCommentVNode("", true),
    ($setup.getWsModalStates.isShowSuccessWsCreationModal)
      ? (_openBlock(), _createBlock(_component_SuccessWorkstationCreationModal, {
          key: 30,
          onOnClose: $setup.onCloseSuccessWorkstationCreationModal
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.rejectConfirmationModal)
      ? (_openBlock(), _createBlock(_component_RejectConfirmationModal, {
          key: 31,
          onOnClose: $setup.onCloseConfirmRejectModal,
          onOnReject: _cache[19] || (_cache[19] = ($event: any) => ($setup.onClickRejectWSInvitation($setup.invitationId)))
        }, null, 8, ["onOnClose"]))
      : _createCommentVNode("", true),
    ($setup.isShowTermsAndConditionModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerTermsConditionModal, {
          key: 32,
          onCloseTermsAndConditionModal: $setup.closeTermsAndConditionModal
        }, null, 8, ["onCloseTermsAndConditionModal"]))
      : _createCommentVNode("", true)
  ], 64))
}